<!--
    SuggestATestPage.vue
    Allows user to submit a single recommendation for a statistical test to the database.
    Sends to a separate collection in Google firebase/firestore not front-facing to the website.
    by Guy E. White <guw968@g.harvard.edu>
-->

<template>
    <div>
        <h2>Suggest a Test</h2>

        <p>I'm doing my best to add more and more material to this awesome database of statistical tests.
        <br><br>If you'd like us to cover something not discussed here, let us know!</p>

        <transition name='fade'>
            <div class='alert' v-if='added'>Your suggestion has been logged!</div>
        </transition>

        <transition name='fade'>
            <div v-if='added == false'>
                <label for='name'>Name of Statistical Test:</label>
                <input
                    type='text'
                    v-model='$v.suggestion.name.$model'
                    id='name'
                    :class='{ "form-input-error": $v.suggestion.name.$error }'
                />

                <div v-if='$v.suggestion.name.$error'>
                    <div
                        class='form-feedback-error'
                        v-if='!$v.suggestion.name.required'
                    >Test name is required.</div>

                    <div
                        class='form-feedback-error'
                        v-if='!$v.suggestion.name.minLength'
                    >Your suggestion must have at least four characters.</div>
                </div>

                <p></p>

                <input data-test='submitButton' type='submit' @click.prevent='submitSuggestion'>

                <div class='form-feedback-error' v-if='$v.$anyError'>
                    Fix the errors above before submitting.
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import * as app from '@/common/app.js';
import { required, minLength } from 'vuelidate/lib/validators'

export default {
    name: '',
    data: function() {
        return {
            added: false,
            suggestion: {
                name: ''
            }
        };
    },
    methods: {
        submitSuggestion: function() {

            this.$v.$touch();

            if (this.$v.$anyError == false) {
                app.api.add('suggestions', this.suggestion).then(id => {
                    this.added = true;
                    console.log('Suggestion recorded with id:' + id);
                    // setTimeout(() => (this.added = false), 3000);

                    this.suggestion = {
                        name: ''
                    }
                });
            }
        }
    },
    validations: {
        suggestion: {
            name: {
                required,
                minLength: minLength(4)
            }
        }
    }
};
</script>

<style scoped>
input {
    font-size: 15pt;
}

textarea,
input[type='text'] {
    width: 50%;
}

textarea {
    height: 75px;
    display: block;
    margin: auto;
}

label {
    margin-top: 20px;
    display: block;
    font-weight: bold;
}

input[type='submit'] {
    display: inline-block;
    margin-top: 10px;
}
</style>
